// @core/api/endpoints/team/create_team_invitation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTeamInvitationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Create team invitation
 * Sends an invitation to join the team. The invitee receives a notification and can accept or decline the invitation.
 */
export async function CreateTeamInvitation(
  team_id: string,
  data: CreateTeamInvitationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/invitations`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
